import { getSelectors } from "../../../../../../modules/EcommContent/ContactLensesEcommContent/context/selectors.js";
const { getEnabledSelectedQuantity } = getSelectors();
const isQuantityValid = (selectedQuantity, maxSelectableQuantity) => selectedQuantity <= maxSelectableQuantity;
const getNewQuantity = (newQuantity, maxQuantity) => {
  return newQuantity > maxQuantity ? maxQuantity : newQuantity;
};
const splitTotalQuantityBetweenEyesides = (state, newTotalQuantity) => {
  const currentTotalQuantity = getEnabledSelectedQuantity(state);
  const maxSelectableBothQuantity = state.configurator.both.quantitySelector.maxSelectableQuantity;
  const maxSelectableLeftQuantity = state.configurator.left.quantitySelector.maxSelectableQuantity;
  const maxSelectableRightQuantity = state.configurator.right.quantitySelector.maxSelectableQuantity;
  const newBothQuantity = getNewQuantity(newTotalQuantity, maxSelectableBothQuantity);
  if (!currentTotalQuantity) {
    return {
      leftQuantity: state.configurations.left.quantity,
      rightQuantity: state.configurations.right.quantity,
      bothQuantity: state.configurations.both.quantity
    };
  }
  if (state.configurator.left.isEnabled && !state.configurator.right.isEnabled) {
    return {
      leftQuantity: getNewQuantity(newTotalQuantity, maxSelectableLeftQuantity),
      rightQuantity: state.configurations.right.quantity,
      // right eye remains the same, because it is disabled
      bothQuantity: newBothQuantity
    };
  }
  if (!state.configurator.left.isEnabled && state.configurator.right.isEnabled) {
    return {
      leftQuantity: state.configurations.left.quantity,
      // left eye remains the same, because it is disabled,
      rightQuantity: getNewQuantity(newTotalQuantity, maxSelectableRightQuantity),
      bothQuantity: newBothQuantity
    };
  }
  return {
    leftQuantity: getNewQuantity(Math.floor(newTotalQuantity / 2), maxSelectableLeftQuantity),
    rightQuantity: getNewQuantity(Math.ceil(newTotalQuantity / 2), maxSelectableRightQuantity),
    bothQuantity: newBothQuantity
  };
};
export {
  isQuantityValid,
  splitTotalQuantityBetweenEyesides
};
//# sourceMappingURL=state-helpers.js.map
